import createCardsetMulti from '@/utils/create-cardset-multi';
import { shuffle } from '@/utils/lib';
import multi from './multi.json';
import results from './results.json';
import mixed1 from './mixed1.json';
import mixed2 from './mixed2.json';

export default () => ({
  '5x10x': createCardsetMulti(multi, shuffle),
  '5x10xresult': results,
  '5x10xM1': mixed1,
  '5x10xM2': mixed2
});
